export default __webpack_public_path__ + "static/media/tag_vending-machine.bf975198.svg";